"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'shortcuts.new.title': 'Aggiungi Nuova Conoscenza',
    'shortcuts.new.description': 'Crea o aggiunge nuova conoscenza al sistema',
};
